import { Slide, ToastOptions, toast } from 'react-toastify';

type NotificationType = 'success' | 'info' | 'warning' | 'error' | "";

export const Notification = (type:NotificationType, message:string) => {
  
  // Store.addNotification({
  //   title: type.toUpperCase(),
  //   message: message,
  //   type: type,
  //   insert: "top",
  //   container: "top-right",
  //   // animationIn: ["animate__animated", "animate__fadeIn"],
  //   // animationOut: ["animate__animated", "animate__fadeOut"],
  //       dismiss: {
  //       duration: 2000,
  //       onScreen: false
  //     }

  // });
  // let config = {
  //   message : type,
  //   description : message
  // };

  // switch (type) {
  //   case 'warning':
  //     notification.warning(config); 
  //     break;
  //   case 'error':
  //     notification.error(config);
  //     break;
  //   case 'info':
  //     notification.info(config);
  //     break; 
  //   case 'success':
  //     notification.success(config);
  //     break;
  //   default:
  //     notification.info(config);
  //     break;
  // }

  


  let config:ToastOptions = {
    position: "top-right",
    autoClose: 1500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    theme: "light",
    transition: Slide,
    };

  switch (type) {
    case 'warning':
      toast.warning(message, config);
      break;
    case 'error':

    toast.error(message, config);
      break;
    case 'info':
      toast.info(message, config);
      break; 
    case 'success':
      toast.success(message, config);
      break;
    default:
      toast(message, config);
      break;
  }

};